export const DEFAULT_SIDEBAR_WIDTH = 320
export const SCROLL_BAR_WIDTH = 17
export const DEFAULT_MAINTENANCE_MESSAGE =
  "Looks like we're down for maintenance.  We'll provide an update on this page when BAM! is " +
  'available again.'
export const DEFAULT_MAINTENANCE_COMPLETE_MESSAGE =
  'Thanks for waiting.  Click the button below to refresh your application.'
